import React, { FunctionComponent } from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from './index';
import { Label } from '../Label';

type SelectOption = {
  label: string;
  value: string;
};

interface SelectSingleComponentProps {
  // name is the name of this form entry.  This is used to generate the ids/keys for the various components.  This
  // should be unique to the form.
  name: string;

  // label is the text that appears above the select.
  label?: string;

  // description (if provided) is some smaller text that appears below the label.
  description?: string;

  // placeholder is the text that appears in the select when no value is selected.
  placeholder?: string;

  // options is an array of options for the select.  Each option should have a label (what's displayed) and a value.
  options: SelectOption[];

  // onChange is a function that is called when the value of the select changes.
  onChange?: (value: string) => void;

  value?: string;

  disabled?: boolean;
}

// SingleComponentSelect is the Select functionality wrapped up in a single component.
export const SelectSingleComponent: FunctionComponent<SelectSingleComponentProps> = ({
  name,
  label,
  description,
  placeholder,
  options,
  value,
  onChange = () => {},
  disabled = false
}) => {
  return (
    <div>
      {label ? (
        <div className="mb-4">
          <Label description={description}>{label}</Label>
        </div>
      ) : null}
      <Select value={String(value)} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {(options || []).map((option) => (
              <SelectItem key={`${name}-${option.value}`} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
